import {
  FILTER_SETS_LIST_REQUESTED,
  FILTER_SETS_LIST_SUCCESS,
  FILTER_SETS_LIST_FAILURE,
  FILTER_SET_DETAILS_REQUESTED,
  FILTER_SET_DETAILS_SUCCESS,
  FILTER_SET_DETAILS_FAILURE,
  FILTER_SET_SAVE_REQUESTED,
  FILTER_SET_SAVE_SUCCESS,
  FILTER_SET_SAVE_FAILURE,
  FILTER_SET_CREATE_REQUESTED,
  FILTER_SET_CREATE_SUCCESS,
  FILTER_SET_CREATE_FAILURE,
  FILTER_SET_DELETE_REQUESTED,
  FILTER_SET_DELETE_SUCCESS,
  FILTER_SET_DELETE_FAILURE,
  FILTER_SET_RESET,
  OPEN_FILTER_SETS,
  CLOSE_FILTER_SETS,
  OPEN_SAVE,
  CLOSE_SAVE,
  OPEN_MANAGE,
  CLOSE_MANAGE,
} from './filterSets.constants'

const initalState = {
  loading: false,
  list: {
    data: [],
    error: null,
  },
  activeItem: {
    key: null,
    details: null,
    error: null,
  },
}

export default (state = initalState, action) => {
  switch (action.type) {
    case FILTER_SETS_LIST_REQUESTED:
    case FILTER_SET_SAVE_REQUESTED:
    case FILTER_SET_CREATE_REQUESTED:
    case FILTER_SET_DELETE_REQUESTED:
      return { ...state, loading: true }

    case FILTER_SETS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          data: action.filterSets,
          error: null,
        },
      }
    case FILTER_SETS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        list: {
          data: [],
          error: action.error.message,
        },
      }

    case FILTER_SET_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
        activeItem: {
          key: action.key,
          details: null,
          error: null,
        },
      }
    case FILTER_SET_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        activeItem: {
          key: state.activeItem.key,
          details: action.filterSet,
          error: null,
        },
      }
    case FILTER_SET_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        activeItem: {
          key: null,
          details: null,
          error: action.error.message,
        },
      }
    case FILTER_SET_RESET:
      return {
        ...state,
        activeItem: {
          key: null,
          details: null,
        },
      }
    case FILTER_SET_SAVE_SUCCESS:
      return {
        ...state,
        loading: true,
        list: { data: [...state.list.data], error: null },
        activeItem: { key: action.id, details: action.result, error: null },
      }
    case FILTER_SET_SAVE_FAILURE:
    case FILTER_SET_CREATE_FAILURE:
      return {
        ...state,
        loading: false,
        list: { data: [...state.list.data], error: action.error.message },
      }

    case FILTER_SET_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        list: { data: action.data, error: null },
      }

    case FILTER_SET_DELETE_SUCCESS: {
      let newActiveItem = state.activeItem
      if (state.activeItem && state.activeItem.key === action.id) {
        newActiveItem = { key: null, details: null, error: null }
      }
      return {
        ...state,
        loading: false,
        list: {
          data: state.list.data.filter(item => item.key !== action.id),
          error: null,
        },
        activeItem: newActiveItem,
      }
    }
    case FILTER_SET_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        list: {
          data: state.list.data,
          error: action.error.message,
        },
      }

    case OPEN_FILTER_SETS:
    case CLOSE_FILTER_SETS:
    case OPEN_SAVE:
    case CLOSE_SAVE:
    case OPEN_MANAGE:
    case CLOSE_MANAGE:
    default:
      return state
  }
}
